import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import ComboBox from "discourse/select-kit/components/combo-box";
import DToggleSwitch from "discourse/ui-kit/d-toggle-switch";
import Icon from "discourse/plugins/chat/discourse/components/chat/header/icon";
import {
  HEADER_INDICATOR_PREFERENCE_ALL_NEW,
  HEADER_INDICATOR_PREFERENCE_DM_AND_MENTIONS,
  HEADER_INDICATOR_PREFERENCE_NEVER,
  HEADER_INDICATOR_PREFERENCE_ONLY_MENTIONS,
} from "discourse/plugins/chat/discourse/lib/chat-constants";
import StyleguideComponent from "discourse/plugins/styleguide/discourse/components/styleguide/component" with {
  discourseImport: "optional",
};
import Controls from "discourse/plugins/styleguide/discourse/components/styleguide/controls" with {
  discourseImport: "optional",
};
import Row from "discourse/plugins/styleguide/discourse/components/styleguide/controls/row" with {
  discourseImport: "optional",
};
import StyleguideExample from "discourse/plugins/styleguide/discourse/components/styleguide-example" with {
  discourseImport: "optional",
};

export default class ChatStyleguideChatHeaderIcon extends Component {
  @tracked isActive = false;
  @tracked currentUserInDnD = false;
  @tracked urgentCount;
  @tracked unreadCount;
  @tracked indicatorPreference = HEADER_INDICATOR_PREFERENCE_ALL_NEW;

  get indicatorPreferences() {
    return [
      HEADER_INDICATOR_PREFERENCE_ALL_NEW,
      HEADER_INDICATOR_PREFERENCE_DM_AND_MENTIONS,
      HEADER_INDICATOR_PREFERENCE_ONLY_MENTIONS,
      HEADER_INDICATOR_PREFERENCE_NEVER,
    ];
  }

  @action
  toggleIsActive() {
    this.isActive = !this.isActive;
  }

  @action
  toggleCurrentUserInDnD() {
    this.currentUserInDnD = !this.currentUserInDnD;
  }

  @action
  updateUnreadCount(event) {
    this.unreadCount = event.target.value;
  }

  @action
  updateUrgentCount(event) {
    this.urgentCount = event.target.value;
  }

  @action
  updateIndicatorPreference(value) {
    this.indicatorPreference = value;
  }

  <template>
    <StyleguideExample @title="<Chat::Header::Icon>">
      <StyleguideComponent>
        <header
          class="d-header"
          style="display: flex; align-items: center; justify-content: center;"
        >
          <ul class="d-header-icons">
            <li class="header-dropdown-toggle chat-header-icon">
              <Icon
                @currentUserInDnD={{this.currentUserInDnD}}
                @indicatorPreference={{this.indicatorPreference}}
                @isActive={{this.isActive}}
                @unreadCount={{this.unreadCount}}
                @urgentCount={{this.urgentCount}}
              />
            </li>
          </ul>
        </header>
      </StyleguideComponent>

      <Controls>
        <Row @name="isActive">
          <DToggleSwitch
            @state={{this.isActive}}
            {{on "click" this.toggleIsActive}}
          />
        </Row>
        <Row @name="currentUserInDnD">
          <DToggleSwitch
            @state={{this.currentUserInDnD}}
            {{on "click" this.toggleCurrentUserInDnD}}
          />
        </Row>
      </Controls>
      <Row @name="Unread count">
        <input
          type="number"
          value={{this.unreadCount}}
          {{on "input" this.updateUnreadCount}}
        />
      </Row>
      <Row @name="Urgent count">
        <input
          type="number"
          value={{this.urgentCount}}
          {{on "input" this.updateUrgentCount}}
        />
      </Row>
      <Row @name="Indicator preference">
        <ComboBox
          @content={{this.indicatorPreferences}}
          @nameProperty={{null}}
          @onChange={{this.updateIndicatorPreference}}
          @value={{this.indicatorPreference}}
          @valueProperty={{null}}
        />

      </Row>
    </StyleguideExample>
  </template>
}
